import React, { useState, useEffect } from "react";
import "./LoadingProgress.css";

const LoadingProgress = ({ 
  isVisible = false, 
  message = "Chargement en cours...", 
  showProgress = true,
  size = "lg",
  color = "warning"
}) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!isVisible) {
      setValue(0);
      return;
    }

    const interval = setInterval(() => {
      setValue((v) => {
        if (v >= 90) {
          clearInterval(interval);
          return 90; // S'arrête à 90% pour laisser la place à la completion
        }
        return v + Math.random() * 15; // Progression aléatoire
      });
    }, 200);

    return () => clearInterval(interval);
  }, [isVisible]);

  useEffect(() => {
    if (isVisible && value >= 90) {
      // Animation de completion
      const timer = setTimeout(() => {
        setValue(100);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isVisible, value]);

  if (!isVisible) return null;

  return (
    <div className="loading-progress-overlay">
      <div className="loading-progress-content">
        {showProgress && (
          <div className="loading-progress-circle">
            <div className="circular-progress">
              <div className="circular-progress-value">{Math.round(value)}%</div>
              <svg className="circular-progress-svg" viewBox="0 0 100 100">
                <circle
                  className="circular-progress-track"
                  cx="50"
                  cy="50"
                  r="40"
                  fill="none"
                  stroke="#f3f4f6"
                  strokeWidth="8"
                />
                <circle
                  className="circular-progress-bar"
                  cx="50"
                  cy="50"
                  r="40"
                  fill="none"
                  stroke={color === "warning" ? "#f59e0b" : color === "primary" ? "#3b82f6" : "#10b981"}
                  strokeWidth="8"
                  strokeDasharray={`${2 * Math.PI * 40}`}
                  strokeDashoffset={`${2 * Math.PI * 40 * (1 - value / 100)}`}
                  strokeLinecap="round"
                />
              </svg>
            </div>
          </div>
        )}
        <div className="loading-progress-message">
          {message}
        </div>
        {!showProgress && (
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingProgress; 